import type { UserInfo } from "./authentication-service";

type SessionInfo = UserInfo & {
    timestamp: number;
};

export class HtmlStorageHelper {
    private static _prefix = `${import.meta.env.VITE_APP_NAME}.`;
    private static _sessionInfo = 'sessionInfo';

    public static saveSessionInfo(sessionInfo: UserInfo) {
        localStorage.setItem(this._prefix + this._sessionInfo, JSON.stringify({ ...sessionInfo, timestamp: Date.now() }));
    }

    public static clearSessionInfo() {
        localStorage.removeItem(this._prefix + this._sessionInfo);
    }

    public static getSessionInfo(): SessionInfo | null {
        const sessionInfo = localStorage.getItem(this._prefix + this._sessionInfo);
        if (sessionInfo) {
            return JSON.parse(sessionInfo);
        }
        return null;
    }

    public static onSessionInfoChange(callback: (sessionInfo: UserInfo | null) => void) {
        window.addEventListener('storage', (event) => {
            if (event.key === this._prefix + this._sessionInfo) {
                callback(this.getSessionInfo());
            }
        });

    }
}

